import type { ButtonProps } from "@nuxt/ui";

export function useInfoToast(title: string, description: string, options?: { timeout?: number; actions?: ButtonProps[] }) {
  if (import.meta.server) {
    return;
  }

  const toast = useToast();
  toast.add({
    icon: "i-ph-chat-circle",
    title: title,
    description: description,
    color: "info",
    duration: options?.timeout ?? 5000,
    actions: options?.actions,
  });
}

export function useSuccessToast(title: string, description: string, options?: { timeout?: number; actions?: ButtonProps[] }) {
  if (import.meta.server) {
    return;
  }

  const toast = useToast();
  toast.add({
    icon: "i-ph-check",
    title: title,
    description: description,
    color: "success",
    duration: options?.timeout ?? 5000,
    actions: options?.actions,
  });
}

export function useWarningToast(title: string, description: string, options?: { timeout?: number; actions?: ButtonProps[] }) {
  if (import.meta.server) {
    return;
  }

  const toast = useToast();
  toast.add({
    icon: "i-ph-info",
    title: title,
    description: description,
    color: "warning",
    duration: options?.timeout ?? 10000,
    actions: options?.actions,
  });
}

export function useFailToast(title: string, description: string, options?: { timeout?: number; actions?: ButtonProps[] }) {
  if (import.meta.server) {
    return;
  }

  const toast = useToast();
  toast.add({
    icon: "i-ph-warning",
    title: title,
    description: description,
    color: "error",
    duration: options?.timeout ?? 15000,
    actions: options?.actions,
  });
}
